__turbopack_context__.v({
  "markdown-container": "markdown-module__nCfrXq__markdown-container",
  "title": "markdown-module__nCfrXq__title",
});
